export const STORAGE_KEYS = {
  PLP_GRID_LAYOUT: "plpGridLayout",
  RECENT_PRODUCT_SEARCHES: "recentProductSearches",
} as const;

type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];

export const getLocalStorage = (key: StorageKey): unknown => {
  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  } catch (error) {
    console.error(
      "getLocalStorage should only be called within a `use client` boundary - " +
        error,
    );

    return null;
  }
};

export const setLocalStorage = (key: StorageKey, value: unknown) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error(
      "setLocalStorage should only be called within a `use client` boundary - " +
        error,
    );
  }
};
